<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    version="1.1"
    id="LicenseIcon"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="21px"
    height="21px"
    viewBox="4.5 2 12 16.5"
    xml:space="preserve"
  >
    <g id="icon">
      <path
        d="M10.5,3L5.5,5v5.5c0,3.9,2.7,6.8,5,7.3c2.3,-0.5,5,-3.4,5,-7.3V5L10.5,3z"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linejoin="round"
        stroke-linecap="round"
      />

      <polyline
        points="8,10.5 9.5,12 13,8.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
